/**
 * Chart Skeleton Component
 * Loading placeholder for chart components
 */

import React from 'react';
import './Skeleton.css';

const ChartSkeleton = ({ height = '400px', showLegend = true }) => {
  return (
    <div className="chart-skeleton" style={{ height }}>
      {/* Chart header skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-line" style={{ width: '200px', height: '24px' }} />
        <div className="skeleton-line" style={{ width: '100px', height: '20px' }} />
      </div>

      {/* Chart body skeleton */}
      <div className="skeleton-chart-body">
        {/* Y-axis */}
        <div className="skeleton-y-axis">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="skeleton-line" style={{ width: '40px', height: '12px' }} />
          ))}
        </div>

        {/* Chart area */}
        <div className="skeleton-chart-area">
          <div className="skeleton-pulse" style={{ width: '100%', height: '100%', borderRadius: '8px' }} />
        </div>
      </div>

      {/* X-axis */}
      <div className="skeleton-x-axis">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="skeleton-line" style={{ width: '50px', height: '12px' }} />
        ))}
      </div>

      {/* Legend */}
      {showLegend && (
        <div className="skeleton-legend">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="skeleton-legend-item">
              <div className="skeleton-circle" />
              <div className="skeleton-line" style={{ width: '80px', height: '14px' }} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChartSkeleton;
